import { useLayoutEffect, useRef, useState } from "react";

const useDynamicSvgImport = (iconName: string, directory: string = "icon") => {
  const ref = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  useLayoutEffect(() => {
    if (!iconName) return;

    setLoading(true);
    const importSvgIcon = async (): Promise<void> => {
      try {
        ref.current = (
          await import(`../../assets/${directory}/${iconName}.svg`)
        ).ReactComponent;
      } catch (err) {
        setError(err);
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    importSvgIcon();
  }, [iconName]);

  return { error, loading, Icon: ref.current };
};

export default useDynamicSvgImport;
